import axios from 'axios';
import { toUpper } from 'lodash';
import { getNGSHeaders } from './utility';

const httpPaytable = (config) => {
  const DC = toUpper(config.platformDataCenter);
  const path = DC ? `VUE_APP_NGS_API_${DC}` : `VUE_APP_NGS_API`;
  const baseURL = config.customDomain
    ? `https://${config.customDomain}/gms`
    : process.env[path];

  return axios.create({
    baseURL,
    timeout: 5000,
  });
};

export default {
  async getPaytable(config) {
    const response = await httpPaytable(config).get(`/api_open/keno/paytable`, {
      headers: getNGSHeaders(config),
    });

    return response.data;
  },
};
